var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"file-box__detail"},[_c('div',{staticClass:"upload-card",on:{"click":_vm.handleClick}},[_c('div',{staticClass:"add-icon"})])])}
var staticRenderFns = []

export { render, staticRenderFns }